<h2 mat-dialog-title>Import CSV File</h2>
<div class="import-dialog">
    <div mat-dialog-content class="mat-dialog-content">
        <mat-form-field class="type">
            <mat-label>Uses Type</mat-label>
            <mat-select #selectType>
                <mat-option *ngFor="let type of usesTypes" [value]="type">
                    {{type.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="type">
            <mat-label>Select Default Use Class</mat-label>
            <mat-select placeholder="Select" [(ngModel)]='selectedClassId'>
                <mat-option *ngFor="let useClass of useClassOptions" [value]="useClass.Id">{{useClass.Label}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="file-chooser">
            <div class="file-name">
                <mat-form-field>
                    <input matInput disabled="true" [value]="getInputValue ? getInputValue : 'No file chosen' ">
                </mat-form-field>
                <button class="cancel-file" mat-icon-button *ngIf="getInputValue" (click)="resetInputFile(fileInput)"
                    [disabled]="!csvData">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div>
                <button class="load-csv-button" mat-flat-button (click)="fileInput.click()">
                    <mat-icon>attach_file</mat-icon>
                    Choose a file
                </button>
                <input hidden type="file" (click)="resetInputFile(fileInput)" #fileInput
                    (change)="csvInputChange($event?.target?.files)" accept=".csv" />
            </div>
        </div>

        <div class="actions-button-container" mat-dialog-actions>
            <button [disabled]="!csvData?.data || !selectType.value" class="action" mat-button mat-raised-button
                (click)="import(selectType.value)">Import</button>
            <button mat-button mat-raised-button cdkFocusInitial (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
